<div class="sheet-download-container">
    <label style="font-size:1.2rem;">Download as</label>
    <div class="row space-above">
        <mat-radio-group class="radio-group" [(ngModel)]="selectedValue">
            @for (option of fileOptions; track option) {
                <mat-radio-button
                                  [value]="option.value">
                    {{option.title}}
                </mat-radio-button>
            }
        </mat-radio-group>
    </div>
    <div class="row btn-action">
        <div class="btn-download" (click)="downloadClicked()">Download</div>
    </div>
</div>
